import { Box, SvgIconProps, Typography } from "@mui/material";
import React from "react";
import { useStyles } from "./styles";

type CircleProgressProps = {
  value: number;
  color: string;
  icon?: React.ReactNode;
  text: string;
  bottomBadge?: React.ReactNode;
};

export default function CircleProgress({
  value,
  color,
  icon,
  text,
  bottomBadge,
}: CircleProgressProps) {
  const classes = useStyles;

  return (
    <Box sx={{ textAlign: "center", paddingTop: 4 }}>
      <Box
        sx={{
          ...classes.circleBox,
          borderColor: color,
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
          margin: "auto",
          position: "relative",
        }}
      >
        <Box sx={classes.icon}>{icon}</Box>
        <Typography
          component={"h4"}
          variant={"h4"}
          sx={{ fontSize: { md: "3rem", xs: "1.8rem" } }}
        >
          {value}
        </Typography>
        {bottomBadge && (
          <Box
            sx={{
              ...classes.bottomBadge,
              borderColor: color,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {bottomBadge}
          </Box>
        )}
      </Box>
      <Typography
        component={"h4"}
        variant={"h4"}
        sx={{
          marginTop: { md: 3, xs: 1 },
          fontSize: { md: "2rem", xs: "1.6rem" },
        }}
      >
        {text}
      </Typography>
    </Box>
  );
}
